export const colors = {
  brand: {
    blue: {
      50: '#E9F2FF',
      100: '#CCE0FF',
      200: '#85B8FF',
      300: '#579DFF',
      400: '#388BFF',
      500: '#1D7AFC',
      600: '#0C66E4',
      700: '#0055CC',
      800: '#09326C',
      900: '#092957',
    },
  },
  neutral: {
    0: '#FFFFFF',
    50: '#F7F8F9',
    100: '#F1F2F4',
    200: '#DCDFE4',
    300: '#B3B9C4',
    400: '#8590A2',
    500: '#758195',
    600: '#626F86',
    700: '#44546F',
    800: '#2C3E5D',
    900: '#172B4D',
    1000: '#091E42',
  },
  green: {
    100: '#DFFCF0',
    200: '#BAF3DB',
    300: '#7EE2B8',
    400: '#4BCE97',
    500: '#2ABB7F',
    600: '#22A06B',
    700: '#1F845A',
  },
  yellow: {
    100: '#FFF7D6',
    200: '#F8E6A0',
    300: '#F5CD47',
    400: '#E2B203',
    500: '#CF9F02',
    600: '#B38600',
  },
  red: {
    100: '#FFE0E0',
    200: '#FFBDBD',
    300: '#FF8F73',
    400: '#F87462',
    500: '#E34935',
    600: '#C9372C',
    700: '#AE2E24',
  },
  purple: {
    100: '#F3F0FF',
    200: '#DFD8FD',
    300: '#B8ACF6',
    400: '#9F8FEF',
    500: '#8270DB',
    600: '#6E5DC6',
  },
} as const;

export const typography = {
  fontFamily: {
    default:
      '-apple-system, BlinkMacSystemFont, "Segoe UI", "Roboto", "Oxygen", "Ubuntu", "Fira Sans", "Droid Sans", "Helvetica Neue", sans-serif',
    mono: '"SFMono-Medium", "SF Mono", "Segoe UI Mono", "Roboto Mono", "Ubuntu Mono", Menlo, Courier, monospace',
  },
  fontSize: {
    h900: '35px',
    h800: '29px',
    h700: '24px',
    h600: '20px',
    h500: '16px',
    h400: '14px',
    h300: '12px',
    h200: '11px',
    h100: '11px',
    body: '14px',
    small: '12px',
    code: '12px',
  },
  fontWeight: {
    regular: 400,
    medium: 500,
    semibold: 600,
    bold: 700,
  },
  lineHeight: {
    tight: 1.2,
    normal: 1.4286,
    relaxed: 1.5,
    loose: 1.714,
  },
} as const;

export const spacing = {
  0: '0',
  50: '2px',
  100: '4px',
  150: '6px',
  200: '8px',
  250: '12px',
  300: '16px',
  400: '24px',
  500: '32px',
  600: '40px',
  800: '64px',
  1000: '80px',
} as const;

export const borderRadius = {
  none: '0',
  small: '3px',
  default: '4px',
  medium: '6px',
  large: '8px',
  circle: '50%',
  pill: '999px',
} as const;

export const elevation = {
  raised: '0 1px 1px rgba(9, 30, 66, 0.25), 0 0 1px rgba(9, 30, 66, 0.31)',
  overflow: '0 0 1px rgba(9, 30, 66, 0.31), 0 8px 12px rgba(9, 30, 66, 0.15)',
  overlay: '0 0 1px rgba(9, 30, 66, 0.31), 0 20px 32px rgba(9, 30, 66, 0.2)',
} as const;
